
// Get all markdown files from the content directory
const modules = import.meta.glob('../content/blog/*.md', { query: '?raw', import: 'default', eager: true });

// Simple frontmatter parser to avoid node Buffer dependencies (gray-matter) in browser
const parseFrontmatter = (fileContent) => {
  const frontmatterRegex = /---\s*([\s\S]*?)\s*---/;
  const match = frontmatterRegex.exec(fileContent);
  
  if (!match) {
    return { data: {}, content: fileContent };
  }

  const frontmatterBlock = match[1];
  const content = fileContent.replace(match[0], '').trim();
  const data = {};

  frontmatterBlock.split('\n').forEach(line => {
    const parts = line.split(':');
    if (parts.length < 2) return;
    
    const key = parts[0].trim();
    let value = parts.slice(1).join(':').trim();
    
    // Remove quotes
    if (value.startsWith('"') && value.endsWith('"')) {
      value = value.slice(1, -1);
    }
    
    // Parse boolean
    if (value === 'true') value = true;
    if (value === 'false') value = false;
    
    // Parse arrays (simple implementation for [item1, item2])
    if (typeof value === 'string' && value.startsWith('[') && value.endsWith(']')) {
      value = value.slice(1, -1).split(',').map(item => {
        item = item.trim();
        if (item.startsWith('"') && item.endsWith('"')) {
          return item.slice(1, -1);
        }
        return item;
      });
    }

    data[key] = value;
  });

  return { data, content };
};

const blogPosts = Object.keys(modules).map((path) => {
  const slug = path.split('/').pop().replace(/\.md$/, '');
  const { data } = parseFrontmatter(modules[path]);
  
  return {
    slug,
    ...data,
  };
});

const blogContent = Object.keys(modules).reduce((acc, path) => {
  const slug = path.split('/').pop().replace(/\.md$/, '');
  const { content } = parseFrontmatter(modules[path]);
  acc[slug] = content;
  return acc;
}, {});

export const getAllPosts = () => {
  return blogPosts.sort((a, b) => new Date(b.date) - new Date(a.date));
};

export const getFeaturedPosts = () => {
  return blogPosts.filter(post => post.featured);
};

export const getPostBySlug = (slug) => {
  const post = blogPosts.find(p => p.slug === slug);
  if (!post) return null;
  
  return {
    ...post,
    content: blogContent[slug] || ''
  };
};

export const getPostsByCategory = (category) => {
  if (category === 'Tous') return getAllPosts();
  return blogPosts.filter(post => post.category === category);
};

export const getPostsByTag = (tag) => {
  return blogPosts.filter(post => post.tags.includes(tag));
};

export const getAllCategories = () => {
  const categories = new Set(blogPosts.map(post => post.category));
  return ['Tous', ...Array.from(categories)];
};

export const getAllTags = () => {
  const tags = new Set(blogPosts.flatMap(post => post.tags));
  return Array.from(tags);
};

export const getRelatedPosts = (currentSlug, limit = 3) => {
  const currentPost = blogPosts.find(p => p.slug === currentSlug);
  if (!currentPost) return [];
  
  return blogPosts
    .filter(post => post.slug !== currentSlug)
    .filter(post => 
      post.category === currentPost.category || 
      post.tags.some(tag => currentPost.tags.includes(tag))
    )
    .slice(0, limit);
};
